import React from 'react';

// Components
import { ExpandingTextAreaInput } from 'components/forms/form-elements';
import HelpText from './help-text';


// This is a component used to display the ticket help text only
// when the ticket description field is active
export default class TimeReportDescription extends React.Component { // eslint-disable-line react/prefer-stateless-function
  constructor() {
    super();
    this.state = {};

    this.onKeyDown = this.onKeyDown.bind(this);
  }

  onKeyDown(event) {
    if (event.keyCode === 13 && event.shiftKey === false) {
      event.preventDefault();
      this.props.form.dispatchEvent(new Event('submit'));
    }
  }

  render() {
    const { meta } = this.props;

    return (
      <div>
        <ExpandingTextAreaInput {...this.props} onKeyDown={this.onKeyDown} />
        <HelpText show={meta.active} container={this}>
          <div>Time reports:</div>
          <ul className="pl-4">
            <li>Seen by clients</li>
            <li>Past tense, no period</li>
            <li>Describe specific actions and results</li>
            <li>Include names</li>
          </ul>
          <div>After hours time reports:</div>
          <ul className="pl-4">
            <li>Mark with "After Hours" billing rate</li>
            <li>Minimum 1 hour per unique issue</li>
          </ul>
          <div className="examples">
            <p>"Checked memory usage, removed startup items, verified improved performance after reboot"</p>
          </div>
        </HelpText>
      </div>
    );
  }
}
